/* @flow */

import React, { useState } from 'react';

// Components
import FolderIcon from 'dibs-vg/dist/react/folder';

// Helpers
import classnames from 'classnames';

// Styles
import styles from './styles.scss';

// Types
type FolderIconWrapperProps = {
    additionalIconClass?: string,
    disabledButton: boolean,
    iconPosition: string,
    iconText?: string,
    isInFolder: boolean,
    isAnimated?: boolean,
    isStrokeWidthHeavy?: boolean,
    type?: 'outline' | 'button',
    onAnimationEnd?: (event: SyntheticEvent<*>) => void,
    onClick: (event: SyntheticEvent<*>) => void,
};

const FolderIconWrapper = (props: FolderIconWrapperProps) => {
    const [isActive, setIsActive] = useState(false);
    const isButton = props.iconPosition === 'relative' || props.iconText;
    const iconClasses = classnames(styles.icon, props.additionalIconClass, {
        [styles.isIcon]: !isButton,
        [styles.isButton]: isButton,
        [styles.isAnimated]: !isButton && props.isAnimated,
        [styles.isFilled]: props.isInFolder,
        [styles.isStrokeWidthHeavy]: props.isStrokeWidthHeavy,
    });
    const iconShadowClasses = classnames(styles.iconShadow, {
        [styles.isAnimated]: props.isAnimated,
    });

    const dataTn = props.isInFolder ? 'folder-saved-icon' : 'folder-save-icon';

    if (props.iconPosition === 'relative' || props.iconText) {
        const buttonClasses = classnames(styles.iconButton, {
            [styles.disabled]: props.disabledButton,
        });

        const buttonIconClasses = classnames(styles.icon, props.additionalIconClass);

        return (
            <button className={buttonClasses} data-tn="add-to-folder" onClick={props.onClick}>
                <FolderIcon className={buttonIconClasses} />
                {props.iconText && <span className={styles.text}>{props.iconText}</span>}
            </button>
        );
    }
    function toggleActive(active) {
        if (props.type === 'button') {
            setIsActive(active);
        }
    }
    return (
        <div
            className={classnames(styles.iconWrapper, {
                [styles[props.type]]: props.type,
                [styles.isActive]: isActive,
                [styles.isStrokeWidthHeavy]: props.isStrokeWidthHeavy,
            })}
            onTouchStart={() => toggleActive(true)}
            onTouchEnd={() => toggleActive(false)}
            onClick={props.onClick}
            data-tn={dataTn}
        >
            <div
                className={classnames(styles.folder, {
                    [styles[props.type]]: props.type,
                })}
            >
                <FolderIcon className={iconClasses} />
                <div className={iconShadowClasses} onAnimationEnd={props.onAnimationEnd} />
            </div>
        </div>
    );
};

FolderIconWrapper.defaultProps = {
    disabledButton: false,
    iconPosition: 'absolute',
    isInFolder: false,
    onClick: () => {},
    type: 'outline',
    isStrokeWidthHeavy: false,
};

export default FolderIconWrapper;
